import {
  AUTO_INCREMENTAL_BLOCK_THRESHOLD,
  INCREMENTAL_SHEET_SWITCH,
} from './mapSwitchFlags';

export function headersStructureKey(headers: string[] | undefined): string {
  if (!Array.isArray(headers) || headers.length === 0) return '';
  return headers.join('\u0001');
}

export function shouldUseIncrementalSwitch(options: {
  processManagerExists: boolean;
  isSheetChange: boolean;
  previousHeadersKey: string;
  nextHeadersKey: string;
  blockCount?: number;
}): boolean {
  const forcedOff = process.env.REACT_APP_INCREMENTAL_SHEET_SWITCH === 'false';
  const forcedOn = INCREMENTAL_SHEET_SWITCH;
  const autoLarge = (options.blockCount ?? 0) >= AUTO_INCREMENTAL_BLOCK_THRESHOLD;
  const incrementalEnabled = !forcedOff && (forcedOn || autoLarge);

  if (!incrementalEnabled) return false;
  if (!options.processManagerExists) return false;
  if (!options.isSheetChange) return false;
  if (options.previousHeadersKey !== options.nextHeadersKey) return false;
  return true;
}
